import {
  Directive,
  computed,
  input,
} from '@angular/core';
import { BrnDialogTitle } from '@spartan-ng/brain/dialog';
import type { ClassValue } from 'clsx';
import { mergeClasses } from 'src/app/@core/utils/merge-classes';

/**
 * Helm dialog title directive (spartan layer).
 * Apply to a heading element inside `hlm-dialog-header` to set the dialog title
 * with proper semantics and typography.
 */
@Directive({
  selector: '[hlmDialogTitle]',
  standalone: true,
  hostDirectives: [BrnDialogTitle],
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmDialogTitleDirective {
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    mergeClasses(
      'text-lg font-semibold leading-none tracking-tight',
      this.userClass(),
    ),
  );
}
